import * as api from '../resources/manage-inventory.api';
import actionTypes from './action-types';

export const fetchPackDetailsRequest = () => ({
  type: actionTypes.FETCH_PACK_DETAILS_REQUEST,
  name: 'packDetailsLoadingStatus',
});

export const fetchPackDetailsSuccess = (packDetails) => ({
  type: actionTypes.FETCH_PACK_DETAILS_SUCCESS,
  packDetails,
  name: 'packDetailsLoadingStatus',
});

export const fetchPackDetailsFailure = () => ({
  type: actionTypes.FETCH_PACK_DETAILS_FAILURE,
  name: 'packDetailsLoadingStatus',
});

export const fetchPackDetails = (config) => async (dispatch, getState) => {
  try {
    const { session, manageInventory } = getState();
    const { locale } = session;
    const { userSelection } = manageInventory;

    const retailerId = userSelection.retailerId || config.retailerId || session.retailer.retailerId;

    const requestParams = {
      ...config,
      ...userSelection,
      retailerId,
      locale,
    };

    dispatch(fetchPackDetailsRequest());

    const packDetails = await api.fetchPackDetails(requestParams);
    dispatch(fetchPackDetailsSuccess(packDetails[0]));
  } catch (error) {
    console.error('FETCH_PACK_DETAILS', error);
    dispatch(fetchPackDetailsFailure());
  }
};



// WEBPACK FOOTER //
// ./src/modules/manage-inventory/actions/fetch-pack-details.actions.js